import { API } from '.';

class PipelineService {
    async sendReport(pipelineId, email) {
        try {
            const response = await API.post('/api/pipelines/report', {
                data: {
                    email: email,
                    pipelineId: pipelineId,
                },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async update(pipelineId, data = {}) {
        try {
            const response = await API.put(`/api/pipelines/${pipelineId}`, {
                data,
            });

            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async create(data) {
        try {
            const response = await API.post('/api/pipelines', {
                data,
            });

            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }
}

export default PipelineService;
